export const RPA_LOGIN_TENANT = 'rpalogin';

export const isRpaLoginTenant = (tenant?: string | null) =>
  String(tenant || '')
    .trim()
    .toLowerCase() === RPA_LOGIN_TENANT;

export const RPA_LOGIN_ACTIONS = [
  {
    id: 'uatRobot',
    label: 'UAT Robot',
  },
  {
    id: 'studio1',
    label: 'Studio 1',
  },
  {
    id: 'studio2',
    label: 'Studio 2',
  },
] as const;

export type RpaLoginActionId = (typeof RPA_LOGIN_ACTIONS)[number]['id'];

export type RpaLoginEc2Status = 'running' | 'offline' | 'starting' | 'shuttingDown';

export type RpaLoginActionCommand = 'start' | 'stop';

export type RpaLoginActionStatus = {
  action: RpaLoginActionId;
  label: string;
  status: RpaLoginEc2Status;
};

export type RpaLoginActionResponse = RpaLoginActionStatus & {
  message: string;
};

export type RpaLoginActionStatusResponse = {
  actions: RpaLoginActionStatus[];
};
